import Image from 'next/image';
import Link from 'next/link';
import MobileMenu from './MobileMenu';
import useMediaQuery from '@/utils/useMediaQuery';
import WhatsAppAndCallButtons from '../WhatsAppAndCallButtons';
import clsx from 'clsx';
import { NavItem } from './Header';
import { COMPANY_DETAILS_QUERYResult } from 'sanity.types';

interface HeaderTopProps {
    navLinks: NavItem[];
    topCompanyDetails: COMPANY_DETAILS_QUERYResult;
}

const HeaderTop = ({ navLinks, topCompanyDetails }: HeaderTopProps) => {
    const companyDetails = topCompanyDetails[0];

    const isBreakpoint = useMediaQuery(768);

    const containerCLasses = clsx(
        'flex',
        'mx-auto',
        'w-full',
        'flex-wrap',
        'md:flex-nowrap',
        'justify-between',
        'relative',
        'sm:mb-2',
        'pb-2'
    );

    const innerContainerClasses = clsx(
        'flex',
        'md:hidden',
        'w-full',
        'mb-2',
        'justify-around',
        'pb-4',
        'border-b-2',
        'border-[#A3C159]'
    );

    return (
        <div className={containerCLasses}>
            <div className={innerContainerClasses}>
                <WhatsAppAndCallButtons
                    companyDetails={companyDetails?.companyDetails}
                    fullWidth
                />
            </div>
            <div className="flex w-full justify-between items-center relative mb-2 md:mb-0">
                {/* Main logo */}
                <Link href="/" className="flex ml-4 md:mx-0 md:mr-16">
                    <Image
                        unoptimized={true}
                        src={companyDetails?.logoUrl as string}
                        alt={(companyDetails?.logoAlt as string) || ''}
                        className="max-w-[260px]"
                        height={56}
                        width={184}
                        style={{ width: 'auto' }}
                        priority
                    />
                </Link>
                <div className="hidden md:flex">
                    <WhatsAppAndCallButtons
                        companyDetails={companyDetails?.companyDetails}
                        fullWidth={true}
                    />
                </div>

                {isBreakpoint && (
                    <MobileMenu
                        logoUrl={companyDetails?.logoUrl}
                        links={navLinks}
                    />
                )}
            </div>
        </div>
    );
};

export default HeaderTop;
